export const updateDatiPianoErogazioniPeriodiche = (unDato, unActionType) => {
  return {
    type: unActionType,
    unDato,
  }
};
